<template>
  <main class="inquiry-form">
    <app-loading class="loading" :isLoading="isLoading"></app-loading>
    <div class="contentBody" :data-loading="isLoading">
      <section class="contentBody__section">
        <form :action="action" :method="method" ref="form">
          <input type="hidden" name="_token" :value="token">
          <form-select
            name="type"
            v-model="type"
            type="select"
            label="お問い合わせの種類"
            :options="inquiryTypes"
            :validation="{ rules: {
            required: true,
          } }"
          ></form-select>

          <form-input
            name="email"
            v-model="email"
            data-vv-name="email"
            type="email"
            label="メールアドレス"
            :validation="{ rules: {
            required: true,
            email: true
          } }"
          ></form-input>

          <form-textarea
            name="body"
            v-model="body"
            :validation="{ rules: {
            required: true
          } }"
            label="お問い合わせ内容"
            placeholder
            :rows="5"
          ></form-textarea>
          <submit-button text="送信" @click="handleSubmit" :disabled="buttonIsDisabled"/>
        </form>
      </section>
    </div>
    <div class="contentFooter" :data-loading="isLoading">
      <div class="u-mg-t-2 u-mg-b-2">
        <div class="subHeadline">＜お問い合わせ受付時間＞</div>
        <p class="description">平日：10:00～19:00</p>
      </div>
      <div class="u-mg-t-2 u-mg-b-2">
        <div class="subHeadline">＜ご注意ください＞</div>
        <p class="description">
          ご利用のメールのセキュリティ設定や、ドメイン指定受信の設定により、
          お客様への返信が届かない場合がございます。
          <b>「uranai.tv」</b>
          からのメールを受信できるように設定をお願いします。
        </p>
      </div>
    </div>

    <app-dialog title="送信完了" :active="completeDialogVisible" @close="closeDialog">
      <div slot="content">
        <p>お問い合わせ内容を送信しました。</p>
        <div class="u-tx-right">
          <base-button
            tag="a"
            label="OK"
            href="/"
          />
        </div>
      </div>
    </app-dialog>
  </main>
</template>

<script>
import SubmitButton from "./partials/SubmitButton"
import BaseButton from "./common/BaseButton"

export default {
  name: 'inquiry-form',
  components: {
    SubmitButton,
    BaseButton
  },
  data() {
    return {
      email: '',
      type: '',
      body: '',
      isLoading: false,
      completeDialogVisible: false,
      token: window.Laravel.csrfToken,
      inquiryTypes: [
        { text: '', value: ''},
        { text: '各種サービスについて', value: '1' },
        { text: '料金・決済について', value: '2' },
        { text: '機種変更・引き継ぎについて', value: '3' },
        { text: '退会について', value: '4' },
        { text: 'その他', value: '0' }
      ],
      validateFlags: {},
      buttonIsDisabled: false,
    };
  },
  props: {
    action: String,
    method: String
  },
  mounted() {
    this.type = this.type || this.inquiryTypes[0].value
    this.validateFlags = this.$validator.flags
  },
  watch:{
    validateFlags: {
      handler(n,o) {
        this.buttonIsDisabled = Object.keys(n).some((key)=>{
          return n[key].invalid
        })
      },
      deep: true
    }
  },
  methods: {
    validation() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll().then(result => {
          if (result === false) {
            const errors = this.$validator.errors.items;
            const $errorsElm = $(`[data-vv-id="${errors[0].id}"]`);
            const isErrorsElmVisible = $errorsElm.css('display') !== 'none';

            if (!isErrorsElmVisible) {
              $errorsElm.show();
            }
            $('html, body').animate({ scrollTop: $errorsElm.offset().top - 56 }, 300);
            if (!isErrorsElmVisible) {
              $errorsElm.hide();
            }
            reject();
          } else {
            resolve();
          }
        });
      });
    },
    handleSubmit() {
      this.validation().then(
        () => {
          this.isLoading = true;
          const fd = new FormData();
          fd.append('email', this.email);
          fd.append('type', this.type);
          fd.append('body', this.body);
          axios.post(this.action, fd).then(
            res => {
              this.isLoading = false;
              if (res.status === 200) {
                this.openDialog();
                this.body = '';
                this.email = '';
                this.email_conf = '';
              }
            },
            error => {
              this.isLoading = false;
              throw new Error(error);
            }
          );
        },
        error => {
          this.isLoading = false;
        }
      );
      return false;
    },
    openDialog() {
      this.completeDialogVisible = true;
    },
    closeDialog() {
      this.completeDialogVisible = false;
    }
  }
};</script>

<style lang="scss" scoped>
.inquiry-form {
  padding: 16px 4px 0;
}
.contentFooter {
  padding-top: 8px;
  &[data-loading='true'] {
    opacity: 0.25;
  }
}
.contentBody {
  position: relative;
  &[data-loading='true'] {
    opacity: 0.25;
  }
}

.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.subHeadline {
  font-weight: bold;
  font-size: 13px;
  line-height: 14px;
}
.description {
  font-size: 11px;
  line-height: 1.4;
  margin-top: 4px;
}
</style>

<style lang="scss">
.inquiry-form textarea.formControl {
  resize: vertical;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/InquiryForm.vue